export class DatetimeModal {
  day: number;
  month: number;
  year: number;
}
